export default __webpack_public_path__ + "static/media/file-text 2.e973c8ef.svg";